import CacheBuster from './CacheBuster'

export default CacheBuster
